var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCheckmarkWavy = function SvgCheckmarkWavy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.106 18.894c-.863-.863-.29-2.674-.73-3.736C3.92 14.058 2.25 13.172 2.25 12s1.67-2.058 2.126-3.158c.44-1.062-.133-2.873.73-3.736s2.674-.29 3.736-.73C9.942 3.92 10.828 2.25 12 2.25s2.058 1.67 3.158 2.126c1.062.44 2.873-.133 3.736.73s.29 2.674.73 3.736c.455 1.1 2.126 1.986 2.126 3.158s-1.67 2.058-2.126 3.158c-.44 1.062.133 2.873-.73 3.736s-2.674.29-3.736.73c-1.1.455-1.986 2.126-3.158 2.126s-2.058-1.67-3.158-2.126c-1.062-.44-2.873.133-3.736-.73Z",
    stroke: "#0B3E21",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m14.704 8.394-3.784 4.97-1.633-2.087a.999.999 0 1 0-1.575 1.232l2.431 3.107a1 1 0 0 0 .788.383h.007a.994.994 0 0 0 .788-.394l4.57-6a.999.999 0 1 0-1.592-1.21Z",
    fill: "#0B3E21"
  })));
};
export default SvgCheckmarkWavy;